module.exports = __webpack_public_path__ + "img/1.c13c934b.jpg";